/* np-arrivals.js: behaviour for sections/new-arrivals.liquid ("New Arrivals.dc.html").
   Category chips, in-stock toggle and sort over the server-rendered cards (the whole
   collection is on the page); adds go through the shared window.npCart API. */
(function () {
  "use strict";
  var grid = document.getElementById("na-grid");
  if (!grid) return;
  var cards = [].slice.call(grid.querySelectorAll("[data-item]"));
  var chips = [].slice.call(document.querySelectorAll("#na-chips [data-pick]"));
  var stock = document.getElementById("na-stock");
  var sort = document.getElementById("na-sort");
  var count = document.getElementById("na-count");
  var none = document.getElementById("na-none");
  var state = { group: "All" };
  var num = function (c, k) { return parseFloat(c.getAttribute("data-" + k)) || 0; };
  var by = {
    "new": function (a, b) { return num(b, "pub") - num(a, "pub"); },
    best: function (a, b) { return num(a, "idx") - num(b, "idx"); },
    low: function (a, b) { return num(a, "price") - num(b, "price"); },
    high: function (a, b) { return num(b, "price") - num(a, "price"); },
    az: function (a, b) { return a.getAttribute("data-name").localeCompare(b.getAttribute("data-name")); }
  };

  function apply() {
    var n = 0;
    cards.slice().sort(by[sort.value] || by["new"]).forEach(function (c) {
      var on = (state.group === "All" || c.getAttribute("data-group") === state.group) &&
        (!stock.checked || c.getAttribute("data-stock") === "1");
      c.hidden = !on;
      if (on) n++;
      grid.appendChild(c);
    });
    count.textContent = n + " product" + (n === 1 ? "" : "s");
    none.hidden = n > 0;
    grid.hidden = n === 0;
  }
  chips.forEach(function (b) {
    b.addEventListener("click", function () {
      state.group = b.getAttribute("data-pick");
      chips.forEach(function (x) {
        var on = x === b;
        x.classList.toggle("is-on", on);
        x.setAttribute("aria-pressed", on ? "true" : "false");
      });
      apply();
    });
  });
  stock.addEventListener("change", apply);
  sort.addEventListener("change", apply);
  document.getElementById("na-reset").addEventListener("click", function () {
    stock.checked = false;
    if (chips[0]) chips[0].click(); else apply();
  });
  apply();

  grid.addEventListener("click", function (e) {
    var b = e.target.closest("[data-atc]");
    if (!b || b.disabled) return;
    if (window.npCart) window.npCart.add([{ id: parseInt(b.getAttribute("data-atc"), 10), quantity: 1 }], { button: b }).catch(function () {});
  });
  if (window.npSwipe) window.npSwipe();
})();
